// extracted by mini-css-extract-plugin
export default {"rarityChart":"rarity-chart_rarityChart__6+tao","rarityLabel":"rarity-chart_rarityLabel__AngGr"};